(function (algolia, $, _, Shopify) {
  'use strict';

  /* No conflict */
  algolia.$ = algolia.jQuery = $;
  algolia._ = algolia.underscore = algolia.lodash = _.noConflict();

  /* Store variables */
  algolia.storeName = window.location.hostname.replace(/^www\./, '').replace(/^([^.]*)\..*$/, '$1');

  /* New lang path */
  algolia.language = 'en';
  algolia.currpath = window.location.pathname;
  var alglobPathSplit =  algolia.currpath.split('/');
  if(alglobPathSplit[1] && alglobPathSplit[1].length == 2){
  	/* Path has lang-key */
 	algolia.language = alglobPathSplit[1];
  	algolia.currpath = algolia.currpath.replace(algolia.language + '/' , '');
  }
  
  /* Client setup */
  algolia.client = algoliasearch(algolia.config.app_id, algolia.config.search_api_key);
  algolia.templates = {};
  algolia.indices = {};
  algolia.full_results = window.location.href.match(/\/search/);
  
  // we want to match /collections/<handle> but only if handle != 'all'
  if(window.location.href.indexOf('/products/') > 0){
    algolia.is_collection_results_page = false;
  } else {
  	algolia.is_collection_results_page = !!algolia.currpath.match(/^\/collections/);
  }
  
  /* We use Hogan as our templating engine with a custom delimiter: [[ ... ]] */
  algolia.hoganOptions = { delimiters: '[[ ]]' };
  algolia.getTemplate = function getTemplate (name) {
    return document.getElementById('template_algolia_' + name).innerHTML;
  };
  algolia.compileTemplate = function compileHoganTemplate (name) {
    return Hogan.compile(algolia.getTemplate(name), algolia.hoganOptions);
  };
  algolia.render = function render (template, obj) {
    obj = _.assign({}, obj, { helpers: algolia.hoganHelpers });
    return template.render(obj);
  };

}(algoliaShopify, $, _, Shopify));
